<template>
	<div>
		<div v-for="(item, index) in keysList" :key="index" class="p-1 mt-2">
			<b-overlay :show="loadingButton && item.UID == selectedKey.UID">
				<div style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; padding: 20px">
					<div class="row">
						<div class="col-12">
							<label class="name"> ФИО </label>
							<div>{{ item.CN }}</div>
						</div>
						<!--						<div class="text-primary col-12">{{ item.CN }}</div>-->
						<div class="col-3">
							<label class="name"> ИНН </label>
							<div>{{ item.TIN }}</div>
						</div>
						<div class="col-4">
							<label class="name"> ПИНФЛ </label>
							<div>{{ item.PINFL }}</div>
						</div>
						<div class="col-5">
							<label class="name"> Номер сертификата </label>
							<div>{{ item.serialNumber }}</div>
						</div>
						<div class="col-4">
							<label class="name"> Организация </label>
							<div>{{ item.O || "-" }}</div>
						</div>
						<div class="col-8">
							<label class="name"> Срок действия сертификата </label>
							<div>
								с {{ ddmmyyyy(item.validFrom) }} до {{ ddmmyyyy(item.validTo) }}
							</div>
						</div>
						<div class="col-12 f mt-4" align="center">
							<button @click="getData(item)" class="btn btn-primary"
								:disabled="new Date(item.validTo).getTime() < Date.now()">
								Выбрать этот ключ
							</button>
						</div>
					</div>
				</div>
			</b-overlay>
		</div>
		<div class="row mt-3" v-if="signdata !== null">
			<div class="col" align="right">
				<button class="btn btn-warning" @click="$emit('cansel', false)">
					{{ $t('cancel') }}
				</button>
				<button class="btn btn-success" style="margin-left: 12px" @click="save()">
					{{ $t('save') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import CurrencyService from "@/services/currency.service";
import { BOverlay } from "bootstrapVue2";

var EIMZO_MAJOR = 3;
var EIMZO_MINOR = 37;

const errorCAPIWS =
	"Ошибка соединения с E-IMZO. Возможно у вас не установлен модуль E-IMZO или Браузер E-IMZO.";
const errorBrowserWS =
	"Браузер не поддерживает технологию WebSocket. Установите последнюю версию браузера.";
const errorUpdateApp =
	'ВНИМАНИЕ !!! Установите новую версию приложения E-IMZO или Браузера E-IMZO.<br /><a href="https://e-imzo.uz/main/downloads/" role="button">Скачать ПО E-IMZO</a>';
const errorWrongPassword = "Пароль неверный.";

import AppSettings from "./settings.json";
// import { useToast } from "vue-toast-notification";
import { UserService } from "@/services/user.service";

export default {
	name: "Signature",
	components: { BOverlay },
	props: ["selectedDoc", "givenDate", "withComment", 'parentmessage'],
	data() {
		return {
			comment: "",
			keysList: [],
			loading: false,
			selectedKey: null,
			loadingButton: false,
			signModal: false,
			currentItem: null,
			modalTitle: null,
			dataToSignIfNot: null,
			dataToSign: null,
			signdata: null
		};
	},
	async created() {
		this.loading = false;
		this.keysList = [];
		await this.appLoad();
	},
	methods: {
		showError(e) {
			this.$vs.notify({
				title: e,
				color: 'danger',
				icon: 'close',
				position: 'top-right'
			})
			this.loading = false
		},
		async sendToBackendSignedData(signedData) {
			console.log(signedData)
			this.signdata = signedData
			try {
				const payload = {

					signedContent: signedData,
					// inn: this.selectedKey.TIN,
					pnfl: this.selectedKey.PINFL,
				};
				if (this.withComment) {
					await this.$emit("success", { ...payload, comment: this.comment });
				} else {
					await this.$emit("success", payload);
				}
			} catch (error) { }
		},
		save() {
			this.loading = true
			this.$emit('save', this.signdata)
		},
		async openSignModal(item) {
			this.currentItem = item;
			this.modalTitle = item.serialNumber + " - " + item.CN;
			if (this.dataToSign === null) {
				this.signByEimzo();
				await CurrencyService.eImzo().then((response) => {
					this.dataToSignIfNot = response.data;
				});
			}
		},
		getCookie(cname) {
			let name = cname + "=";
			let decodedCookie = decodeURIComponent(document.cookie);
			let ca = decodedCookie.split(";");
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == " ") {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		},
		clearCookie(name) {
			document.cookie = name + "=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
		},
		setCookie(cname, cvalue) {
			var now = new Date();
			var time = now.getTime();
			time += 3600 * 6000;
			now.setTime(time);
			let expires = "expires=" + now.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		},
		async signByEimzo() {
			this.loadingButton = true;
			let vm = this;
			var data = this.dataToSignIfNot;
			const promise = new Promise((resolve, reject) => {
				let keyId = this.getCookie("keyId-" + vm.currentItem.TIN);
				if (keyId == "") {
					EIMZOClient.loadKey(
						vm.currentItem,
						function (id) {
							EIMZOClient.createPkcs7(
								id,
								data,
								null,
								function (pkcs7) {
									vm.setCookie("keyId-" + vm.currentItem.TIN, id);
									resolve(pkcs7);
								},
								function (e, r) {
									reject("error");
									vm.loadingButton = false;
									if (r) {
										if (r.indexOf("BadPaddingException") != -1) {
											vm.showError(errorWrongPassword);
										} else {
											vm.showError(r);
										}
									} else {
										document.getElementById("keyId").innerHTML = "";
										vm.showError(errorBrowserWS);
									}
									if (e) vm.showError(e);
								}
							);
						},
						function (e, r) {
							reject("error");
							vm.loadingButton = false;
							if (r) {
								if (r.indexOf("BadPaddingException") != -1) {
									vm.showError(errorWrongPassword);
								} else {
									vm.showError(r);
								}
							} else {
								vm.showError(errorBrowserWS);
							}
							if (e) vm.showError(e);
						}
					);
				} else {
					EIMZOClient.createPkcs7(
						keyId,
						data,
						null,
						function (pkcs7) {
							resolve(pkcs7);
						},
						function (e, r) {
							reject("error");
							vm.loadingButton = false;
							if (r) {
								vm.clearCookie("keyId-" + vm.currentItem.TIN);
								if (r.indexOf("BadPaddingException") != -1) {
									vm.showError(errorWrongPassword);
								} else {
									vm.showError(r);
								}
							} else {
								document.getElementById("keyId").innerHTML = "";
								vm.showError(errorBrowserWS);
							}
							if (e) vm.showError(e);
						}
					);
				}
			});
			promise
				.then(
					async (success) => {
						await vm.sendToBackendSignedData(success);
					},
					(error) => {
						vm.showError(error);
						this.signdata = null
					}
				)
				.finally(() => {
					vm.signModal = false;
					vm.loadingButton = false;
				});
		},
		async getData(item) {
			this.selectedKey = item;
			await this.openSignModal(this.selectedKey);
		},
		uiCreateItem(itmkey, vo) {
			let vm = this;
			var now = new Date();
			vo.expired = dates.compare(now, vo.validTo) > 0;
			var itm = document.createElement("option");
			itm.value = itmkey;
			itm.text = vo.CN;
			if (!vo.expired) {
			} else {
				itm.style.color = "gray";
				itm.text = itm.text + " (срок истек)";
			}
			vm.keysList.push(vo);
			itm.setAttribute("vo", JSON.stringify(vo));
			itm.setAttribute("id", itmkey);
			return itm;
		},
		async uiLoadKeys() {
			let vm = this;
			EIMZOClient.listAllUserKeys(
				function (o, i) {
					var itemId = "itm-" + o.serialNumber + "-" + i;
					return itemId;
				},
				function (itemId, v) {
					return vm.uiCreateItem(itemId, v);
				},
				function (items, firstId) {
					//vm.uiFillCombo(items);
					//vm.uiComboSelect(firstId);
				},
				function (e, r) {
					vm.showError(errorCAPIWS);
				}
			);
		},
		appLoad() {
			let vm = this;
			vm.loading = true;
			EIMZOClient.API_KEYS = AppSettings.api_keys;
			EIMZOClient.checkVersion(
				function (major, minor) {
					var newVersion = EIMZO_MAJOR * 100 + EIMZO_MINOR;
					var installedVersion = parseInt(major) * 100 + parseInt(minor);
					if (installedVersion < newVersion) {
						vm.loading = false;
						vm.showError(errorUpdateApp);
					} else {
						EIMZOClient.installApiKeys(
							function () {
								vm.loading = false;
								vm.uiLoadKeys();
							},
							function (e, r) {
								vm.loading = false;
								if (r) {
									vm.showError(r);
								} else {
									vm.showError(e);
								}
							}
						);
					}
				},
				function (e, r) {
					vm.loading = false;
					if (r) {
						vm.showError(r);
					} else {
						vm.showError(e);
					}
				}
			);
		},
		ddmmyyyy(date) {
			var yyyy = date.getFullYear().toString();
			var mm = (date.getMonth() + 1).toString(); // getMonth() is zero-based
			var dd = date.getDate().toString();
			return (dd[1] ? dd : "0" + dd[0]) + "-" + (mm[1] ? mm : "0" + mm[0]) + "-" + yyyy; // padding
		},
	},
};
</script>
<style scoped>
.card {
	box-shadow: -1px 3px 10px 0 rgb(0 0 0 / 6%);
	border-radius: 10px;
	padding: 20px;
	border: 1px solid #d9d6d6;
}

.name {
	font-weight: bold;
}
</style>
